<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
      <div class="d-sm-flex align-items-center">
        <router-link
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 rounded-1 bg-success fs-md-15 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
          to="/ajouter-organe">
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
          Ajouter un organe
        </router-link>
      </div>

      <div class="d-flex align-items-center">
        <form class="search-box position-relative me-15" @submit.prevent="rechercher">
          <input type="text" v-model="searchTerm" @keyup="rechercher"
            class="form-control shadow-none text-black rounded-0 border-0" placeholder="Rechercher un organe" />
          <button type="submit" class="bg-transparent text-primary transition p-0 border-0">
            <i class="flaticon-search-interface-symbol"></i>
          </button>
        </form>
      </div>
    </div>

    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th class="text-uppercase fw-medium text-body-tertiary fs-13 pt-0">Nom de l’organe</th>
              <th class="text-uppercase fw-medium text-body-tertiary fs-13 pt-0">Postes associés</th>
              <th class="text-uppercase fw-medium text-body-tertiary fs-13 pt-0 pe-0">Actions</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="(organe, index) in organes || []" :key="index">
              <td class="shadow-none fw-semibold text-black">
                {{ organe.nom }}
              </td>
              <td>
                <ul class="mb-0 ps-3">
                  <li v-for="poste in organe.postes || []" :key="poste.id" class="mb-1">
                    <span class="fw-medium">{{ poste.nomPoste }}</span>
                    <small class="text-muted" v-if="poste.arrondissement?.libelle">
                      ({{ poste.arrondissement?.libelle }})
                    </small>
                  </li>
                </ul>
              </td>

              <!-- Actions -->
              <td class="text-end pe-0">
                <div class="dropdown">
                  <span class="badge text-white bg-primary fs-15 dropdown-toggle" data-bs-toggle="dropdown">
                    Actions
                  </span>
                  <ul class="dropdown-menu">
                    <li>
                      <router-link :to="{ name: 'edit-organes', params: { id: organe.id } }"
                        class="dropdown-item d-flex align-items-center">
                        <i class="flaticon-pen lh-1 me-8"></i> Modifier
                      </router-link>
                    </li>
                    <li>
                      <a href="javascript:void(0);" class="dropdown-item d-flex align-items-center"
                        @click="suppression(organe.id, organes, 'organes', `l'organe ${organe.nom}`)">
                        <i class="flaticon-delete lh-1 me-8"></i> Supprimer
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>

            <tr v-if="!(organes?.length) || organes.length === 0">
              <td colspan="3" class="text-center text-muted py-4">
                Aucun organe trouvé
              </td>
            </tr>

          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <div class="pagination-area d-md-flex mt-15 justify-content-between align-items-center">
        <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit"
          @paginate="handlePaginate" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import ApiService from "@/services/ApiService";
import { error, suppression } from "@/utils/utils";
import PaginationComponent from "@/components/Utilities/Pagination.vue";

export default defineComponent({
  name: "ListeOrganes",
  components: { PaginationComponent },
  setup() {
    const organes = ref<any[]>([]);
    const searchTerm = ref("");
    const page = ref(1);
    const totalPages = ref(0);
    const totalElements = ref(0);
    const limit = ref(10);

    


function rechercher() {
      getAllOrgane(page.value, limit.value, searchTerm.value);
    }
function getAllOrgane(page_ = 1, limit_ = 10, searchTerm = "") {
     return ApiService.get(
        `/organes?page=${page_}&limit=${limit_}&mot=${searchTerm}&`
      )
        .then((response) => {
          console.log("Réponse brute du backend:", response.data);
 
          // Le tableau des organes
          organes.value = response.data.data.data || [];
 
          // On calcule la pagination côté front
          totalElements.value = organes.value.length;
          totalPages.value = Math.ceil(totalElements.value / limit.value);
          limit.value = limit_; // garde la valeur actuelle
 
          console.log("Organes récupérés:", organes.value);
          console.log("Pagination:", {
            totalPages: totalPages.value,
            totalElements: totalElements.value,
            limit: limit.value
          });
        })
        .catch((err) => {
          const msg = err.response?.data?.message || "Erreur lors du chargement des organes";
          error(msg);
        });
    }


    /*function getAllOrgane(page = 1, limi = 10, searchTerm = "") {
      return ApiService.get(
        `/all/organes?page=${page}&limit=${limi}&mot=${searchTerm}&`
      )
        .then(({ data }) => {
          organes.value = data.data.data;
          totalPages.value = data.data.totalPages;
          limit.value = data.data.limit;
          totalElements.value = data.data.totalElements;
          return data.data;
        })
        .catch(({ response }) => {
          error(response.data.message);
        });
    }*/

    const handlePaginate = ({ page_, limit_ }: { page_: number; limit_: number }) => {
      page.value = page_;
      getAllOrgane(page_, limit_, searchTerm.value);
    };

   

    onMounted(() => getAllOrgane());

    return {
      organes,
      page,
      totalPages,
      limit,
      totalElements,
      handlePaginate,
      rechercher,
      searchTerm,
      suppression,
      
    };
  },
});
</script>
